"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tableCustomerListConfig = void 0;
const react_1 = __importDefault(require("react"));
const Icon_1 = require("../../Icon");
exports.tableCustomerListConfig = [
    {
        Header: 'Email',
        accessor: 'email',
    },
    {
        Header: () => 'Phone',
        id: 'phone',
        Cell: ({ row }) => {
            const customer = row.original;
            const phoneMap = (phone, idx) => (react_1.default.createElement("span", { key: `pl-tplc::${idx}`, style: { display: 'block' } }, phone));
            return (react_1.default.createElement("span", null, [
                customer.phoneMobile,
                customer.phoneNumberFirst,
                customer.phoneNumberSecond,
            ].filter(value => !!value).map(phoneMap)));
        },
        disableSortBy: true,
    },
    {
        Header: 'Address',
        accessor: 'street',
        disableShowForDevice: true,
    },
    {
        Header: 'City',
        accessor: 'city',
        disableShowForDevice: true,
    },
    {
        Header: 'Zip',
        accessor: 'zip',
        disableSortBy: true,
        disableShowForDevice: true,
    },
    {
        Header: () => 'Info',
        id: 'info',
        Cell: () => {
            return (react_1.default.createElement("span", { className: 'table__action-icons' },
                react_1.default.createElement("span", { className: 'table__action-icon' },
                    react_1.default.createElement(Icon_1.Icon, { name: 'edit' })),
                react_1.default.createElement("span", { className: 'table__action-icon' },
                    react_1.default.createElement(Icon_1.Icon, { name: 'check-list' })),
                react_1.default.createElement("span", { className: 'table__action-icon' },
                    react_1.default.createElement(Icon_1.Icon, { name: 'x' }))));
        },
    },
];
//# sourceMappingURL=tableCustomerListConfig.js.map